module.exports = __webpack_public_path__ + "img/yishidingqikaohe.3c30326a.png";